<template>
    <el-card shadow="never" class="system-entry-config">
        <el-form label-width="190px" size="small">
            <el-form-item label="报价助手">
                <el-input v-model.trim="bjzsUrl" placeholder="请输入报价助手入口 URL" />
            </el-form-item>
            <el-form-item label="爱企查">
                <el-input v-model.trim="qccUrl" placeholder="请输入爱企查入口 URL" />
            </el-form-item>
            <el-form-item label="国家电子税务局">
                <el-input v-model.trim="nationalTaxUrl" placeholder="请输入国家电子税务局入口 URL" />
            </el-form-item>
            <el-form-item label="国家企业信用公示网">
                <el-input v-model.trim="publicityUrl" placeholder="请输入国家企业信用公示网入口 URL" />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" :loading="saving" @click="save">保存配置</el-button>
            </el-form-item>
        </el-form>
    </el-card>
</template>

<script>
export default {
    name: 'SystemEntryConfig',
    data() {
        return {
            saving: false,
            nationalTaxId: null,
            qccId: null,
            publicityId: null,
            bjzsId: null,
            nationalTaxUrl: '',
            qccUrl: '',
            publicityUrl: '',
            bjzsUrl: ''
        };
    },
    created() {
        this.fetchConfig();
    },
    methods: {
        fetchConfig() {
            var _this = this;
            window.axios.get('/quick-links').then(function (response) {
                var list = response.data.data || [];
                var nationalTaxItem = null;
                var qccItem = null;
                var publicityItem = null;
                var bjzsItem = null;

                for (var i = 0; i < list.length; i += 1) {
                    var item = list[i];
                    if (Number(item.link_type) === 5) {
                        nationalTaxItem = item;
                    } else if (Number(item.link_type) === 3) {
                        qccItem = item;
                    } else if (Number(item.link_type) === 4) {
                        publicityItem = item;
                    } else if (Number(item.link_type) === 6) {
                        bjzsItem = item;
                    }
                }

                _this.nationalTaxId = nationalTaxItem && nationalTaxItem.id ? Number(nationalTaxItem.id) : null;
                _this.qccId = qccItem && qccItem.id ? Number(qccItem.id) : null;
                _this.publicityId = publicityItem && publicityItem.id ? Number(publicityItem.id) : null;
                _this.bjzsId = bjzsItem && bjzsItem.id ? Number(bjzsItem.id) : null;
                _this.nationalTaxUrl = nationalTaxItem && nationalTaxItem.url ? String(nationalTaxItem.url) : '';
                _this.qccUrl = qccItem && qccItem.url ? String(qccItem.url) : '';
                _this.publicityUrl = publicityItem && publicityItem.url ? String(publicityItem.url) : '';
                _this.bjzsUrl = bjzsItem && bjzsItem.url ? String(bjzsItem.url) : '';
            });
        },
        save() {
            var _this = this;
            var requests = [];

            requests.push(this.upsertLink(5, this.nationalTaxUrl, this.nationalTaxId));
            requests.push(this.upsertLink(3, this.qccUrl, this.qccId));
            requests.push(this.upsertLink(4, this.publicityUrl, this.publicityId));
            requests.push(this.upsertLink(6, this.bjzsUrl, this.bjzsId));

            this.saving = true;
            Promise.all(requests).then(function () {
                _this.$message.success('系统入口配置已保存');
                _this.fetchConfig();
            }).catch(function (error) {
                var message = error && error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : '系统入口配置保存失败';
                _this.$message.error(message);
            }).finally(function () {
                _this.saving = false;
            });
        },
        upsertLink(linkType, url, currentId) {
            let name;

            switch (linkType) {
                case 5:
                    name = '国家电子税务局入口';
                    break;
                case 3:
                    name = '爱企查入口';
                    break;
                case 4:
                    name = '国家企业信用公示网入口';
                    break;
                case 6:
                    name = '报价助手';
                    break;
                default:
                    name = '';
                    break;
            }

            var payload = {
                province: '系统入口',
                link_type: linkType,
                name: name,
                url: (url || '').trim(),
                status: 1,
                sort_order: 1
            };

            if (!payload.url) {
                payload.url = '#';
            }

            if (currentId) {
                return window.axios.put('/quick-links/' + currentId, payload);
            }

            return window.axios.post('/quick-links', payload);
        }
    }
};
</script>

<style scoped>
.system-entry-config {
    margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/SystemEntryConfig.vue